import type { ReactElement } from "react";
import styles from "./styles.module.scss";
import { stringConstants } from "~/locale/stringConstants";

export function NoApp(): ReactElement {
    return <div className={styles.root}>{stringConstants.components.NoApp.Message}</div>;
}
